import { render, staticRenderFns } from "./TiktokAuthorization.vue?vue&type=template&id=7554e3fe&scoped=true"
import script from "./TiktokAuthorization.vue?vue&type=script&lang=js"
export * from "./TiktokAuthorization.vue?vue&type=script&lang=js"
import style0 from "./TiktokAuthorization.vue?vue&type=style&index=0&id=7554e3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7554e3fe",
  null
  
)

export default component.exports